import { ClientJS } from "clientjs";

export default function getSystemInfo() {
	const client = new ClientJS();
	return {
		fingerprint: String(client.getFingerprint()),
		browser: {
			name: client.getBrowser(),
			version: client.getBrowserVersion(),
			engine: {
				name: client.getEngine(),
				version: client.getEngineVersion(),
			},
			userAgent: client.getUserAgent(),
			plugins: client.getPlugins(),
			mimeTypes: client.getMimeTypes(),
			features: {
				localStorage: client.isLocalStorage(),
				sessionStorage: client.isSessionStorage(),
				cookie: client.isCookie(),
				canvas: client.isCanvas(),
			},
			language: client.getLanguage(),
		},
		device: {
			name: client.getDevice(),
			type: client.getDeviceType(),
			vendor: client.getDeviceVendor(),
			softwareVersion: client.getSoftwareVersion(),
			architecture: client.getCPU(),
			isMobile: client.isMobile(),
			os: {
				name: client.getOS(),
				version: client.getOSVersion(),
			},
			displays: [
				{
					resolution: {
						current: client.getCurrentResolution(),
						available: client.getAvailableResolution(),
					},
					xdpi: client.getDeviceXDPI(),
					ydpi: client.getDeviceYDPI(),
				},
			],
			time: {
				current: Date.now(),
				timezone: client.getTimeZone(),
				timezoneName: Intl.DateTimeFormat().resolvedOptions().timeZone,
			},
		},
	};
}
